import { ILanguageService } from "../../service/language/LanguageService";
import { IStore } from "../../model/runtime/state/Store";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { UserPreferences } from "../../common/Constants";
import { ILanguage } from "../../model/language/Language";

export default class LoadLanguagesInteractor {
  private languageService: ILanguageService;
  private store: IStore;
  private credentialsService: ICredentialsService;

  constructor(store, languageService, credentialsService) {
    this.store = store;
    this.languageService = languageService;
    this.credentialsService = credentialsService;
  }

  async getCurrentLanguageCode() {
    const currentLanguage = await this.credentialsService.getLanguage();
    return Number(currentLanguage);
  }

  async execute() {
    const languages = await this.languageService.getLanguages();
    let currentLanguageCode = await this.getCurrentLanguageCode();
    currentLanguageCode = currentLanguageCode
      ? currentLanguageCode
      : UserPreferences.DEFAULT_LANGUAGE;

    const selectedLanguage = languages.find(
      (langugage: ILanguage) => langugage.code === currentLanguageCode
    );
    this.store.update({ languages, selectedLanguage });
  }
}
